<template>
  <div>
    <ToastHost />
  </div>
</template>

<script>
import ToastHost from './ToastHost.vue';

// Rendered by front.layouts.layout as <global-component> on every SPA page.
export default {
  name: 'GlobalComponent',
  components: { ToastHost },
};
</script>
